import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import './scss/style.scss';
import history from './history';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-158587-7');

history.listen(location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const AuthRoute = ({ component: Component, loginUser, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => 
        !Array.isArray(loginUser) ? (
          <TheLayout {...props} />
        ) : (
          // <TheLayout {...props} />
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./views/pages/forgotPassword/ResetPassword'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {

  render() {
    
    const { auth } = this.props;
    // console.log(this.props.authUser)

    return (
      <Router history={history} basename={'/data'}>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/" name="Home" render={props => <TheLayout {...props}/>} />
            <Route exact path="/dashboard" name="Home" render={props => <TheLayout {...props}/>} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
            <Route path="/political" name="Home" render={props => <TheLayout {...props} />} />

            { localStorage.token === undefined ? <Redirect to={{ pathname: '/login', state: {from: this.props.location } }} /> : <AuthRoute
              name="Home"
              path="/clients"
              auth={auth}
              render={props => <TheLayout {...props} />}
            /> }
            {/* <AuthRoute
              name="Home"
              auth={auth}
              render={props => <TheLayout {...props} />}
            /> */}
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

const mapStateToProps = ({ auth, settings }) => {
  const { locale } = settings;
  return { auth, locale };
};
const mapActionsToProps = {};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(App);